var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513V341.992H0V-0.0078125Z",
    fill: "#2D6E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.902 286.161C282.415 286.161 333.902 234.674 333.902 171.161C333.902 107.648 282.415 56.1611 218.902 56.1611C155.389 56.1611 103.902 107.648 103.902 171.161C103.902 234.674 155.389 286.161 218.902 286.161Z",
    fill: "#F40B32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default __webpack_public_path__ + "static/media/BD.e7072e2b3f9e61e28654c7e4af22cbce.svg";
export { ForwardRef as ReactComponent };